import { PAYMENT_FUNCTIONS } from '../config/functionRoutes';
import { getAuth } from 'firebase/auth';

const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_URL || 
  (process.env.REACT_APP_FIREBASE_PROJECT_ID === 'runnershubtest' 
    ? 'https://europe-west1-runnershubtest.cloudfunctions.net'
    : 'https://europe-west1-runnershub-62442.cloudfunctions.net');

export interface CreateCheckoutSessionResponse {
  checkoutSessionId: string;
  url: string;
}

export async function createStripeCheckoutSession(registrationId: string, language?: string): Promise<CreateCheckoutSessionResponse> {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }

  const idToken = await user.getIdToken();
  const origin = window.location.origin;

  const response = await fetch(`${FUNCTIONS_BASE_URL}/${PAYMENT_FUNCTIONS.checkout}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    },
    body: JSON.stringify({ registrationId, origin, language }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return response.json();
}

export async function redirectToStripeCheckout(registrationId: string, language?: string): Promise<void> {
  const { url } = await createStripeCheckoutSession(registrationId, language);
  if (url) {
    window.location.href = url;
  } else {
    throw new Error('No checkout URL returned');
  }
}
